// src/utils/displayValue.js

export function displayValue(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => displayValue(item)).filter(Boolean).join(", ");
  }

  if (typeof value === "object") {
    if (value.Value !== undefined) {
      return displayValue(value.Value);
    }

    if (value.Title !== undefined) {
      return displayValue(value.Title);
    }

    if (value.Email !== undefined) {
      return displayValue(value.Email);
    }

    if (value.LookupValue !== undefined) {
      return displayValue(value.LookupValue);
    }

    if (value.Name !== undefined) {
      return displayValue(value.Name);
    }

    return "";
  }

  return String(value);
}

export default displayValue;
